export default __webpack_public_path__ + "static/FAM20738000-9722a338892a1b9c65ee91978cd05e8a.jpg";